import renderValue from '../../../components/formBuilder/utility/renderValue';
import FormUIOptions from '../../../components/formBuilder/formElements/formUIOptions';

export const getLift = (rentAmount, marketRentAmount) => {
  const lift = {};

  if ((rentAmount || rentAmount === 0) && marketRentAmount) {
    lift.percent = ((marketRentAmount - rentAmount) / rentAmount) * 100;
    lift.amount = marketRentAmount - rentAmount;

    lift.percent = Math.round(lift.percent) + '%';

    lift.amount = renderValue(
      { name: 'liftAmount', type: FormUIOptions.Money, decimalPlaces: 0 },
      { liftAmount: lift.amount }
    );

    return `${lift.amount} (${lift.percent})`;
  }

  if (marketRentAmount && !rentAmount) {
    lift.amount = marketRentAmount;
    lift.percent = '100%';

    lift.amount = renderValue(
      { name: 'liftAmount', type: FormUIOptions.Money, decimalPlaces: 0 },
      { liftAmount: lift.amount }
    );

    return `${lift.amount} (${lift.percent})`;
  }

  return '-';
};

export const getMonthly = (data) =>
  data ? (data.unit === 'yearly' ? data.value / 12 : data.value) : undefined;
